export enum eUserType {
  Admin = 'Admin',
  LenderUser = 'LenderUser',
  LenderCompany = 'LenderCompany',
  ClientUser = 'ClientUser',
  ClientCompany = 'ClientCompany',
  VendorUser = 'VendorUser',
}

export const prettyUserType: Record<eUserType, string> = {
  [eUserType.Admin]: 'Spruce',
  [eUserType.LenderUser]: 'Lender',
  [eUserType.LenderCompany]: 'Lender API',
  [eUserType.ClientUser]: 'Client',
  [eUserType.ClientCompany]: 'Client API',
  [eUserType.VendorUser]: 'Vendor',
};
